import { TableRow as MuiTableRow } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { TableCell, type IRowDefault } from 'shared/ui/TableNew'
import { Button } from 'shared/ui'

type ILoadMoreExpandedRowProps<TRow extends IRowDefault> = {
  row: TRow
}

export const LoadMoreExpandedRow = observer(
  <TRow extends IRowDefault>({ row }: ILoadMoreExpandedRowProps<TRow>) => {
    return (
      <MuiTableRow>
        <TableCell
          sx={{
            paddingLeft: '72px',
          }}
        >
          {() => (
            <Button
              onClick={row.onLoadMore}
              contained={'secondary'}
              size={'small'}
              text={'Load more'}
              loading={row.loadingMore}
            />
          )}
        </TableCell>
      </MuiTableRow>
    )
  }
)
